
import { Component, Prop, Vue } from 'nuxt-property-decorator';

@Component
export default class NftCardBurnInfo extends Vue {
  @Prop(Number) readonly burnTime!: number;
  @Prop(Boolean) readonly isBurned!: boolean;

  get isBurnTimeInFuture() {
    return Date.now() < this.burnTime;
  }

  get messageTextPath() {
    return `components.films.filmItemForSale.${
      this.isBurned ? `itemWasRemovedAndBurned` : `itemWillBeRemovedAndBurned`
    }`;
  }
}
